import React, { useEffect, useMemo, useState } from 'react';
import { useMenuContext } from '../../context';
import { EMenuOpenType } from '../../types';
import Button from './Button';
import Container from './Container';
import IoTIcon from './IoTIcon';
import { Tooltip } from './Tooltip';

type Props = {
  onOpen: () => void;
  onClose?: () => void;
  setMenuIsOpen: (menuIsOpen: boolean) => void;
  hasBeenOpened: boolean;
  menuIsOpen: boolean;
  hideTriggerButton?: boolean;
  top?: number;
};

export default function IoTMTriggerButton({
  onOpen,
  onClose,
  setMenuIsOpen,
  hasBeenOpened,
  menuIsOpen,
  hideTriggerButton,
  top,
}: Props) {
  const { settings, openType, open, colors } = useMenuContext();

  const [leftOffset, setLeftOffset] = useState(178);
  const tooltipRef = React.useRef<HTMLDivElement>(null);
  const tooltipOn = useMemo(
    () => settings.tooltipOnIot && !hasBeenOpened,
    [settings.tooltipOnIot, hasBeenOpened],
  );
  useEffect(() => {
    if (tooltipOn) return;

    if (tooltipRef.current?.offsetWidth) {
      setLeftOffset(tooltipRef.current?.offsetWidth + 58);
    }
  }, [tooltipOn, tooltipRef.current?.offsetWidth]);

  return (
    <>
      {!hideTriggerButton && (
        <Container hasBeenOpened={hasBeenOpened} tooltipOn={!!tooltipOn} leftOffset={leftOffset} top={top}>
          {tooltipOn && (
            <Tooltip
              ref={tooltipRef}
              label="IoTMenu"
              hasBeenOpened={hasBeenOpened}
              bgColor={colors.iotBg}
              textColor={colors.iotText}
            />
          )}
          <Button
            onOpen={onOpen}
            onClose={onClose}
            setMenuIsOpen={setMenuIsOpen}
            active={open ? openType === EMenuOpenType.IoT : false}
            icon={<IoTIcon color={colors.iotText} />}
            menuIsOpen={menuIsOpen}
            hasBeenOpened={hasBeenOpened}
            bgColor={colors.iotBg}
            textColor={colors.iotText}
            openOnHover={settings.openOnHoverIot}
          />
        </Container>
      )}
    </>
  );
}
